import useMobileCartPageExperiment from './use-mobile-cart-page-experiment'

export default useMobileCartPageExperiment
